import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Avatar } from '@digsup/components-avatar';
import { Icon } from '@digsup/components-icon';
import { styles } from './Relationship.scss';

const cx = classNames.bind(styles);

/**
  Relationship component
  ~~~js
    import { Relationship } from '@digsup/components-relationship';
  ~~~
 */

const getChildSize = (type, size) => {
  if (type === 'Avatar') return size === 'medium' ? 'large' : 'xlarge';
  return size === 'medium' ? 'xlarge' : 'xxlarge';
};

export const Relationship = ({
  joinIconName,
  size,
  className,
  children,
  ...props
}) => {
  const classes = cx('c-relationship', className);

  let content = [];
  let outlined = true;

  React.Children.map(children, child => {
    if (
      (child.type.displayName === 'Avatar' ||
        child.type.displayName === 'Icon') &&
      content.length < 2
    ) {
      if (!child.props.src) outlined = false;
      content.push(child);
    }
  });

  content = content.map((child, i) => {
    let contentProps = null;

    if (child.type.displayName === 'Avatar') {
      contentProps = {
        isInverted: true,
        isOutlined: outlined,
      };
    }

    return React.cloneElement(child, {
      className: cx('c-relationship__item', {
        [child.props.className]: !!child.props.className,
      }),
      shape: child.type.displayName === 'Icon' ? 'round' : null,
      size: getChildSize(child.type.displayName, size),
      key: `${child.type.displayName}${child.props.size}${i}`,
      ...contentProps,
    });
  });

  return (
    <div className={classes} {...props}>
      {content}
      <Icon
        name={joinIconName}
        size={size === 'medium' ? 'small' : 'medium'}
        fill="white"
        shapeColor="tenacious"
        shape="round"
        className="c-relationship__type"
      />
    </div>
  );
};

Relationship.propTypes = {
  /**
   * join(middle) icon name - one of design system icon names (see Icon component stories)
   */
  joinIconName: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['medium', 'large']),
  className: PropTypes.string,
  /**
   * oneOf: Avatar, Icon components
   */
  children: PropTypes.arrayOf(
    PropTypes.objectOf(Avatar),
    PropTypes.objectOf(Icon),
  ),
};

Relationship.defaultProps = {
  size: 'medium',
  className: '',
};
